export const parseLineHTML = (text) => text.replace(/\n/g, '<br>');
